import $ from 'jquery'
import {isEmpty,mediaPath,locale,root,acc,loopFocus} from '../Helpers';

export default class Statement {

    constructor() {
        this._data = {}
    }

    get elem() {  return this._data.elem }
    set elem(x) {  this._data.elem = x  }

    get statement() {  return this._data.statement }
    set statement(x) {  this._data.statement = x  }

    get statement_url() {  return this._data.statement_url }
    set statement_url(x) {  this._data.statement_url = x  }

    get_statement(){
        if(!isEmpty(this.statement)){
           this.open()
            return
        }
        /*todo loader?*/
        const url  =  acc('statement_url')
        $.post(url)
            .done((res) => {
                console.log(res)
                if (res.success) {
                    this.statement = res.data
                    this.open()
                    }
                else{}
               })
            .fail((e) => {
               console.log(e)
            });
    }

    open() {
        this.elem = $('<div>', {id: 'acc_statement','class':'acc_pop','tabindex':'0'})
        const header = $('<header>')
        const close = $('<button>',{
            'class':"acc-close-btn",
            'aria-label':locale('close_statement')
        }).click(()=>this.close())
        const title = $('<h2>').text(locale('acc_statement'))
        header.html([ close,  title  ])
        const inner = $('<div>',{'class':'acc_pop_inner'}).html(this.statement)
        this._content = $('<div>', {'class': 'acc_pop_content'}).html([header,inner])
        const overlay = $('<div>', {'class': 'acc_pop_overlay'})
        this.elem.html([this._content, overlay])
        root().elem.append(this.elem)
        this.elem.focus()
        loopFocus(this.elem)
        inner.outerHeight(this._content.height() - header.outerHeight() - (parseInt(this._content.css('borderTop'))*2))

    }
    close(){
        if(isEmpty(this.elem)){return}
        this.elem.fadeOut('fast',()=>{
            this.elem.remove()
            this.elem=null
        })
    }



}
